export default "__VITE_ASSET__e1e54338__"